import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import useClickOutside from '@hooks/useClickOutside';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';
import FilterName from '@features/filter/v2/FilterName';

import {
	removeItemFromGlobalFilter,
	storeItemInGlobalFilter,
	storeSelectedFilterCheckboxType
} from '@store/actions/FilterAction';

const Location = ({ isDependentFilter }) => {
	const [countryData, setCountryData] = useState([]);
	const [cityData, setCityData] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const dispatch = useDispatch();
	const checkboxRef = useRef();

	useEffect(() => {
		onFetchData();
		onFetchCityData();
	}, [dependentFilterList]);

	const onOutSideClick = () => {
		dispatch(storeSelectedFilterCheckboxType(null));
	};

	useClickOutside(checkboxRef, onOutSideClick);

	const onFetchData = async () => {
		let responseData = isDependentFilter
			? dependentFilterList?.countryResponse
			: responseData?.map((item) => {
					return { id: item.id, name: item.name };
				});
		setCountryData(responseData);
	};

	const onFetchCityData = async () => {
		let responseData = isDependentFilter
			? dependentFilterList?.cityResponseList
			: responseData?.map((item) => {
					return { id: item.id, name: item.name };
				});
		setCityData(responseData);
	};

	const onCountryCLick = (item) => {
		dispatch(removeItemFromGlobalFilter({ name: 'cityId_value', identifier: 'cityId_value' }));
		let data = {
			name: 'countryId',
			key: item.id,
			value: item.value,
			identifier: `countryId_${item.id}`,
			type: 'SELECT'
		};
		dispatch(storeItemInGlobalFilter(data));
		onFetchCityData(item.id);
	};
	const onCityCLick = (item) => {
		let data = {
			name: 'cityId_value',
			key: item.value,
			value: item.value,
			identifier: 'cityId_value',
			type: 'SELECT'
		};
		dispatch(storeItemInGlobalFilter(data));
	};
	return (
		<div>
			<FilterName type="LOCATION" />
			{selectedField?.selectedCheckboxField === 'LOCATION' && (
				<div className="filter-submenu scroll-y-label" ref={checkboxRef}>
					<div className="card border-0">
						<div className="card-body">
							<div className="col-md-12 p-0">
								<div className="form-group mb-2">
									<CustomDropdown
										type="addItem"
										title={'Country'}
										onItemClick={(value) => onCountryCLick(value)}
										items={countryData?.map((item) => ({
											id: item.id,
											value: item.name,
											key: item.name
										}))}
										// selectedItem={
										// 	getFilterTextFieldValue(filterData, 'countryId', 'countryId')
										// 		?.value
										// }
										selectedItem={filterData?.countryId?.[0]?.value}
									/>
								</div>
							</div>

							<div className="col-md-12 p-0">
								<div className="form-group mb-2">
									<CustomDropdown
										type="addItem"
										title={'City'}
										onItemClick={onCityCLick}
										items={cityData
											?.filter(
												(item) => item.countyId === filterData?.countryId?.[0]?.key
											)
											.map((item) => ({
												id: item.id,
												value: item.name,
												key: item.name
											}))}
										selectedItem={
											getFilterTextFieldValue(
												filterData,
												'cityId_value',
												'cityId_value'
											)?.value
										}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default Location;
